import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b6bdfe2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "goods_list" }
const _hoisted_4 = { class: "list_operate" }
const _hoisted_5 = { class: "goods_item_img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "goods_item_content" }
const _hoisted_8 = { class: "goods_item_title" }
const _hoisted_9 = { class: "goods_item_desc_price" }
const _hoisted_10 = { class: "goods_item_desc_price" }
const _hoisted_11 = { class: "goods_item_footer" }
const _hoisted_12 = { class: "goods_item_footer_edit" }
const _hoisted_13 = {
  key: 1,
  class: "empty_wrap"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref, watch, reactive, unref } from 'vue';
import { Modal } from 'ant-design-vue';
import { emptyDataImgTxt } from '@/assets';
import { VueDraggableNext } from 'vue-draggable-next';
import type { Imodal } from '@/views/live/place/Place.vue';
import ModalEditGood from './ModalEditGood.vue';
import { GoodItem } from '../type';
import { dragDrop } from '@/utils/format/dragDrop';

interface IProps {
  modelValue: GoodItem[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'GoodList',
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: GoodItem[];
};

const aModal = Modal;
const draggable = VueDraggableNext;
const dragOptions = ref({
  animation: 200,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
});


const form = ref<GoodItem[]>([]);
form.value = unref(props.modelValue);

watch(form, (newVal) => {
  emit('update:modelValue', newVal);
});

const onAddGood = () => {
  form.value.push({
    title: '示例商品',
    img: process.env.VUE_APP_OTHER_LINK+'/default_shop.svg',
    link: 'http://qing.tv',
    price: '99.00',
    origin_price: '100.00',
    btn_name: '购买',
  });
};
const onDelGood = (index: number) => {
  form.value.splice(index, 1);
};

const itemForm = ref<GoodItem>({
  title: '',
  img: '',
  link: '',
  price: '',
  origin_price: '',
  btn_name: '',
});
const goodId = ref(0);

//  modal
const formModal = reactive<Imodal>({
  title: '修改商品信息',
  visible: false,
  loading: false,
});
const closeEditModal = () => {
  goodId.value = 0;
  formModal.visible = false;
  formModal.loading = false;
  itemForm.value = {
    title: '',
    img: '',
    link: '',
    price: '',
    origin_price: '',
    btn_name: '',
  };
};
const openEditModal = (index: number) => {
  goodId.value = index;
  itemForm.value = form.value[index];
  formModal.visible = true;
};
const createGood = () => {
  form.value.splice(goodId.value, 1, itemForm.value);
  closeEditModal();
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (form.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_button, {
                class: "mod_modal_btn sm",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onAddGood()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加")
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(draggable), _mergeProps({
              class: "goods_item_wrap c_scroll",
              list: form.value
            }, dragOptions.value, { onDrop: _unref(dragDrop) }), {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "goods_item list-group-item",
                    key: index
                  }, [
                    _withDirectives(_createElementVNode("div", _hoisted_5, [
                      _createElementVNode("img", {
                        class: "img",
                        src: item.img,
                        alt: ""
                      }, null, 8, _hoisted_6)
                    ], 512), [
                      [_vShow, item.img]
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h4", _hoisted_8, _toDisplayString(item.title), 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(item.price), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(item.origin_price), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_a_button, {
                            class: "gifbtn",
                            type: "link",
                            onClick: ($event: any) => (openEditModal(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("修改")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_a_button, {
                            class: "gifbtn",
                            type: "link",
                            onClick: ($event: any) => (onDelGood(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("删除")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _createVNode(_component_a_button, {
                          class: "gifbtn_buy",
                          type: "link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.btn_name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 16, ["list", "onDrop"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("img", {
            class: "empty_tbody_img",
            src: _unref(emptyDataImgTxt),
            alt: ""
          }, null, 8, _hoisted_14),
          _createElementVNode("p", null, [
            _createTextVNode(" 暂无商品，可点击 "),
            _createVNode(_component_a_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onAddGood())),
              type: "link",
              class: "empty_tbody_link"
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加")
              ]),
              _: 1
            }),
            _createTextVNode(" 创建～ ")
          ]),
          _hoisted_15
        ])),
    _createVNode(_unref(aModal), {
      visible: formModal.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((formModal.visible) = $event)),
      title: formModal.title,
      width: 480,
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (closeEditModal())),
      centered: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (closeEditModal()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "mod_modal_btn mod_type_primary",
          loading: formModal.loading,
          onClick: createGood
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(ModalEditGood, {
          modelValue: itemForm.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((itemForm).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})